import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { SPECIALIST, USER, GLOBAL } from '@/constant';

import specialist, { specialistPersistField } from '@/store/specialist';
import user, { userPersistField } from '@/store/user';
import global, { globalPersistField } from '@/store/global';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    [SPECIALIST]: specialist,
    [USER]: user,
    [GLOBAL]: global
  },
  plugins: [
    createPersistedState({
      key: 'vuex-patient-consulted',
      paths: [
        ...specialistPersistField.map(field => `${SPECIALIST}.${field}`),
        ...userPersistField.map(field => `${USER}.${field}`),
        ...globalPersistField.map(field => `${GLOBAL}.${field}`)
      ]
    })
  ]
});
